import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { FormInputComponent } from "../../../form";

@Component({
  selector: "adaa-comments-editor-modal",
  imports: [TranslatePipe, FormInputComponent],
  templateUrl: "./comments-editor-modal.html",
  styleUrl: "./comments-editor-modal.scss",
})
export class CommentsEditorModalComponent {
  modal: NgbActiveModal = inject(NgbActiveModal);

  @Input() cardTitle: string = "";
  comment: string = "";
}
